import { TileSectionIds } from '@dataplace.ai/constants'
import { IPoisTileData } from '@placeme/components/organisms/Tiles/Market/Pois/@types/IPoisTileData'
import { RootState } from 'apps/placeme/src/redux/store'
import { tilesIds } from 'libs/shared/constants/src/lib/tilesIds'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

function useCheckPDFTooLong(): boolean {
  const { values } = useSelector((state: RootState) => state.analysis)

  const poisData = useMemo(() =>
    values?.find(c => c.id === TileSectionIds.MARKET)?.tiles
      ?.find(tile => tile.id.includes(tilesIds.market.pois))?.data as IPoisTileData, [values])

  const comparedItemsLength = poisData?.value?.comparedLocation?.pois?.length ?? 0

  return (poisData?.value.filteredPoisLength
    ? poisData?.value.filteredPoisLength
    : poisData?.value.pois.length + comparedItemsLength) > 100
}

export default useCheckPDFTooLong
